module.exports = __webpack_public_path__ + "static/media/plane_straight.4d5f9268.svg";